type IconProps = {
	width?: number;
	height?: number;
	color?: string;
}

export const LoadDroppedIcon = (props:IconProps) => {
	const {
		width = 20,
		height = 20,
		color = 'var(--brand-orange-default)'
	} = props;
	return (
		<svg role={'img'} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={'0 0 20 20'} fill={color}>
			<path d="M11.92,3.88l-6.07,3.47,6.04,3.47,6.04-3.47-6.01-3.47ZM3.26,16.01V7.78c0-.34.08-.65.24-.92.16-.28.39-.5.68-.67l6.75-3.91c.16-.08.32-.15.47-.2.15-.05.31-.08.49-.08s.34.03.5.08c.16.05.31.12.45.21l6.76,3.91c.29.17.52.39.68.67.16.28.24.59.24.92v4.73h-1.85v-3.47l-6.81,3.91-6.76-3.91v6.94l6.17,3.57v2.13l-7.09-4.09c-.29-.15-.52-.37-.68-.65s-.24-.6-.24-.94ZM15.58,23l2.46-2.46,2.46,2.46,1.27-1.27-2.46-2.46,2.46-2.46-1.27-1.27-2.46,2.46-2.46-2.46-1.27,1.27,2.46,2.46-2.46,2.46,1.27,1.27Z"/>
		</svg>
	);
};
